<template>
    <PaletteChip :id_palette="idPalette">{{ compRep }}</PaletteChip>
</template>



<script setup>
// Usage: 
//   import StatusChip from '@/features/workorders/workorder/controls/StatusChip'
//
//   <StatusChip :model="model"></StatusChip>
import {computed} from 'vue'
import PaletteChip from "@controls/widgets/PaletteChip.vue";
import Constants from '@app/consts'

const props = defineProps({
    model: {
        type: [Object]
    },
})

// The palette contains red, which is color 4. 
// Lets skip that one. 
const idPalette = computed({
    get() {
        if (props.model?.finished_at) {
            return 5;
        }
        if (props.model?.canceled_at) {
            return 4;
        }

        switch (props.model?.id_status) {
            case Constants.workorder.status.STATUS_CONCEPT: return 0;
            case Constants.workorder.status.STATUS_PLANNED: return 2;
            case Constants.workorder.status.STATUS_EXECUTING: return 3;
            case Constants.workorder.status.STATUS_EXECUTED: return 5;
        }

        return 0;
    }
})

const compRep = computed({
    get() {
//        if (props.model?.finished_at) {
//            return "Gereed";
//        }
//        if (props.model?.canceled_at) {
//            return "Vervallen";
//        }
        switch (props.model?.id_status) {
            case Constants.workorder.status.STATUS_CONCEPT: return "Concept";
            case Constants.workorder.status.STATUS_PLANNED: return "Ingepland";
            case Constants.workorder.status.STATUS_EXECUTING: return "In uitvoering";
            case Constants.workorder.status.STATUS_EXECUTED: return "Uitgevoerd";
            default: 
            break; 
        }
        return "Concept";
    }
})


</script>
